class EntitiesFormatter {
  user(user) {
    const name = user.name.replace(/"/g, '').trim();
    const hasName = !!name;
    const brands = user.customer_accounts || [];
    return Object.assign({}, user, {
      displayName: hasName ? name : user.email,
      displayId: user.email,
      displayDetail: hasName ? user.email : '',
      name,
      hasName,
      customer_accounts: brands.map((brand) => this.brand(brand)),
    });
  }
  brand(brand) {
    const users = brand.user_accounts || [];
    return Object.assign({}, brand, {
      displayName: brand.name,
      displayId: brand.photorank_id,
      displayDetail: brand.photorank_id,
      user_accounts: users.map((user) => this.user(user)),
    });
  }
}

export default EntitiesFormatter;
